import React, { Component } from "react"
import { translate } from "react-i18next"
import Widget from "../Layout/Widget"
import Donut from "../../Graphs/DonutChart"

class AveragePerformanceScoreDonut extends Component {
  render() {
    const { t, i18n } = this.props
    const widgetTitle = t("WidgetTitles.AveragePerformance")
    return (
      <Widget title={widgetTitle} widthLg={4} widthMd={4}>
        <Donut
          value={82}
          maxValue={100}
          units="%"
          leftComparisonTitle="Last 6 months"
          leftComparisonValue={60}
          rightComparisonTitle="Last 3 months"
          rightComparisonValue={99}
        />
      </Widget>
    )
  }
}

export default translate("translations")(AveragePerformanceScoreDonut)



// WEBPACK FOOTER //
// ./src/Components/Widgets/Performance/AveragePerformanceScoreDonut.js